class ExtendSectionBase {
  constructor() {
    this._flktyListObj = {};
    this._sectionLoadObj = {};
    this._sectionLoadListening = false;
    this._flktyResizeTimers = {};
  }

  _q(s, c = document) {
    return c.querySelector(s);
  }

  _qa(s, c = document) {
    return [...c.querySelectorAll(s)];
  }

  _syncFlktyWidth({ flktyInstance, maxWidth } = {}) {
    if (!flktyInstance) return;
    let totalWidth = 0;
    flktyInstance.cells.forEach((cell) => {
      let style = window.getComputedStyle(cell.element);
      totalWidth +=
        cell.element.offsetWidth +
        parseInt(style.marginLeft) +
        parseInt(style.marginRight);
    });
    if (!maxWidth) maxWidth = window.innerWidth * 0.9;
    flktyInstance.element.style.width = Math.min(totalWidth, maxWidth) + "px";
    flktyInstance.resize();
  }

  _syncFlktyHeight($flktyContainer, flktyInstance) {
    if (
      !flktyInstance ||
      !flktyInstance.cells ||
      !flktyInstance.cells[0] ||
      !flktyInstance.cells[0].size
    ) {
      return;
    }
    const cellH = flktyInstance.cells[0].size.height;
    $flktyContainer.css("height", cellH + "px");
  }

  _bindFlktyResizeDebounce(flktyInstance, key, callback, delay = 100) {
    flktyInstance.on("resize", () => {
      clearTimeout(this._flktyResizeTimers[key]);
      this._flktyResizeTimers[key] = setTimeout(callback, delay);
    });
  }

  _waitAndSetEqualHeight(flktyEl, flktyInstance, maxTries = 60) {
    const attempt = (triesLeft) => {
      const cells = flktyEl.querySelectorAll(".flickity-cell");
      if (cells.length > 0) {
        this._setFlktyCellsEqualHeight(flktyEl, flktyInstance);
      } else if (triesLeft > 0) {
        requestAnimationFrame(() => attempt(triesLeft - 1));
      } else {
        console.warn(
          "[ExtendSectionBase] flickity cells 未渲染，等高失败",
          flktyEl
        );
      }
    };
    requestAnimationFrame(() => attempt(maxTries));
  }

  _setFlktyCellsEqualHeight(flktyContainer, flktyInstance) {
    var container =
      flktyContainer && flktyContainer.jquery
        ? flktyContainer[0]
        : flktyContainer;
    if (!container || container.nodeType !== 1) {
      return;
    }
    let items = Array.prototype.slice.call(
      container.querySelectorAll(".flickity-cell")
    );
    if (!items.length) {
      return;
    }
    // 清除旧高度，获取自然高度
    items.forEach(function (item) {
      item.style.height = "auto";
      item.style.boxSizing = "border-box";
    });
    let maxHeight = Math.max.apply(
      null,
      items.map(function (item) {
        return item.getBoundingClientRect().height;
      })
    );
    // 统一设置为最高高度
    items.forEach(function (item) {
      item.style.height = maxHeight + "px";
    });
  }

  _clearFlktyList(flktyListName) {
    const flktyList = this._flktyListObj[flktyListName];
    if (!flktyList || flktyList.length <= 0) return;
    flktyList.forEach((item) => {
      !!item.destroy && item.destroy();
    });
  }

  _resizeFlktyListAll() {
    Object.keys(this._flktyListObj).forEach((key) => {
      const list = this._flktyListObj[key];
      if (!list || list.length <= 0) return;
      list.forEach((flktyItem) => {
        !!flktyItem.resize && flktyItem.resize();
      });
    });
  }

  _registerSectionLoad(key, className, funName, onLoad) {
    let options = null;
    if (key && typeof key === "object" && !Array.isArray(key)) {
      options = key;
    } else {
      options = {
        key: key,
        className: className,
        funName: funName,
        onLoad: onLoad,
      };
    }
    if (!options.key || !options.className) {
      return;
    }
    this._sectionLoadObj[options.key] = {
      className: options.className,
      funName: options.funName || null,
      onLoad: typeof options.onLoad === "function" ? options.onLoad : null,
    };
  }

  _listenSectionLoad() {
    if (this._sectionLoadListening) return;
    this._sectionLoadListening = true;
    document.addEventListener("shopify:section:load", (event) => {
      const sectionEl = event.target || event.srcElement;
      if (!sectionEl || !sectionEl.classList) return;
      Object.values(this._sectionLoadObj).forEach(
        ({ className, funName, onLoad }) => {
          if (!sectionEl.classList.contains(className)) return;

          // 有回调时，直接更新原有闭包中的 DOM 引用
          if (typeof onLoad === "function") {
            onLoad(sectionEl);
            return;
          }

          // 兼容原有的 section 初始化逻辑
          if (funName && typeof this[funName] === "function") {
            this[funName]();
          }
        }
      );
    });
  }

  _isDivInViewport($div) {
    const el = $div instanceof $ ? $div[0] : $div;
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  onResize() {
    this._resizeFlktyListAll();
  }
}
